import { useMemo } from 'react';

import { useDraftProgress } from '../contexts/DraftProgressProvider';
import type { DraftSteps } from '../utils/types';

export const useDraftStepData = (step: DraftSteps) => {
  const { data } = useDraftProgress();

  const stepData = useMemo(() => data[step], [data, step]);

  return stepData;
};
